module.exports = __webpack_public_path__ + "static/media/icon_jiaoyu.ca63b597.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/icon_jiaoyu.png
// module id = 2162
// module chunks = 0